/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateOrganizationRequestLegalInfo } from './CreateOrganizationRequestLegalInfo';
import {
    CreateOrganizationRequestLegalInfoFromJSON,
    CreateOrganizationRequestLegalInfoFromJSONTyped,
    CreateOrganizationRequestLegalInfoToJSON,
    CreateOrganizationRequestLegalInfoToJSONTyped,
} from './CreateOrganizationRequestLegalInfo';
import type { CreateOrganizationRequestSubscription } from './CreateOrganizationRequestSubscription';
import {
    CreateOrganizationRequestSubscriptionFromJSON,
    CreateOrganizationRequestSubscriptionFromJSONTyped,
    CreateOrganizationRequestSubscriptionToJSON,
    CreateOrganizationRequestSubscriptionToJSONTyped,
} from './CreateOrganizationRequestSubscription';

/**
 * 
 * @export
 * @interface CreateOrganizationRequest
 */
export interface CreateOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    leadId?: string;
    /**
     * 
     * @type {CreateOrganizationRequestLegalInfo}
     * @memberof CreateOrganizationRequest
     */
    legalInfo: CreateOrganizationRequestLegalInfo;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOrganizationRequest
     */
    products: Array<string>;
    /**
     * 
     * @type {CreateOrganizationRequestSubscription}
     * @memberof CreateOrganizationRequest
     */
    subscription: CreateOrganizationRequestSubscription;
}

/**
 * Check if a given object implements the CreateOrganizationRequest interface.
 */
export function instanceOfCreateOrganizationRequest(value: object): value is CreateOrganizationRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('legalInfo' in value) || value['legalInfo'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    if (!('subscription' in value) || value['subscription'] === undefined) return false;
    return true;
}

export function CreateOrganizationRequestFromJSON(json: any): CreateOrganizationRequest {
    return CreateOrganizationRequestFromJSONTyped(json, false);
}

export function CreateOrganizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'address': json['address'],
        'email': json['email'] == null ? undefined : json['email'],
        'leadId': json['leadId'] == null ? undefined : json['leadId'],
        'legalInfo': CreateOrganizationRequestLegalInfoFromJSON(json['legalInfo']),
        'products': json['products'],
        'subscription': CreateOrganizationRequestSubscriptionFromJSON(json['subscription']),
    };
}

export function CreateOrganizationRequestToJSON(json: any): CreateOrganizationRequest {
    return CreateOrganizationRequestToJSONTyped(json, false);
}

export function CreateOrganizationRequestToJSONTyped(value?: CreateOrganizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'address': value['address'],
        'email': value['email'],
        'leadId': value['leadId'],
        'legalInfo': CreateOrganizationRequestLegalInfoToJSON(value['legalInfo']),
        'products': value['products'],
        'subscription': CreateOrganizationRequestSubscriptionToJSON(value['subscription']),
    };
}

